import { SVGIconComponent } from './types';

export const Add: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Action/Add" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M13,4 C17.96395,4 22,8.0360725 22,13 C22,17.964775 17.9638,22 13,22 C8.03617,22 4,17.964775 4,13 C4,8.0360725 8.0360725,4 13,4 Z M13,5.5 C8.8645,5.5 5.5,8.8645 5.5,13 C5.5,17.13625 8.8645,20.5 13,20.5 C17.1355,20.5 20.5,17.13625 20.5,13 C20.5,8.8645 17.1355,5.5 13,5.5 Z M13,9.25 C13.414225,9.25 13.75,9.58579 13.75,10 L13.75,12.25 L16,12.25 C16.414225,12.25 16.75,12.585775 16.75,13 C16.75,13.414225 16.414225,13.75 16,13.75 L13.75,13.75 L13.75,16 C13.75,16.414225 13.414225,16.75 13,16.75 C12.585775,16.75 12.25,16.414225 12.25,16 L12.25,13.75 L10,13.75 C9.58579,13.75 9.25,13.414225 9.25,13 C9.25,12.585775 9.58579,12.25 10,12.25 L12.25,12.25 L12.25,10 C12.25,9.58579 12.585775,9.25 13,9.25 Z"
        id="Combined-Shape"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
